module.exports = __webpack_public_path__ + "static/media/6.9c06dbe9.jpg";